import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BankDetailsChangePaymentKind, BankDetailsChangePaymentMethod } from 'apps/webapp/src/app/@core/data/selfservice-forms/bank-details-change';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'payment-details',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SelectModule,
    InputTextModule,
    DatePickerModule,
    TooltipModule,
    CheckboxModule
  ],
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss'],
  standalone: true,
})
export class PaymentDetailsComponent implements OnInit {
  @Input() form: FormGroup;

  translate = inject(TranslateService);

  paymentKindsOptions = Object.values(BankDetailsChangePaymentKind);
  paymentMethodsOptions = [BankDetailsChangePaymentMethod.BANK_TRANSFER];
  protected readonly BankDetailsChangePaymentMethod = BankDetailsChangePaymentMethod;

  abi = signal<string | null>(null)
  cab = signal<string | null>(null)

  constructor() { }

  ngOnInit(): void {
    this.form.get('iban')?.valueChanges.subscribe((iban: string) => {
      this.updateAbiAndCab(iban);
    });
  }

  private updateAbiAndCab(iban: string) {
    if (!iban || iban.length < 15) {
      this.abi.set(null)
      this.cab.set(null)
      return;
    }

    // trim spaces just in case
    const cleanIban = iban.replace(/\s+/g, '');

    const abi = cleanIban.substring(5, 10); // 6th to 10th "digit"
    const cab = cleanIban.substring(10, 15); // 11th to 15th "digit"

    this.abi.set(abi);
    this.cab.set(cab);
  }


  get _paymentKindsOptions() {
    return this.paymentKindsOptions.map(opt => {
      return {
        label: this.translate.instant(`selfservice-request.bank-details-change.payment-kind.${opt.toLowerCase()}`),
        value: opt
      }
    });
  }

  get _kindOptions() {
    return this.paymentMethodsOptions.map(opt => {
      return {
        label: this.translate.instant(`selfservice-request.bank-details-change.payment-method.${opt.toLowerCase()}`),
        value: opt
      }
    });
  }

  onChangePaymentMethod(): void {
    this.form.get('iban')?.setValue(undefined);
    this.form.get('accountCoHolder')?.get('firstName')?.setValue(undefined);
    this.form.get('accountCoHolder')?.get('lastName')?.setValue(undefined);
    if (this.form.get('kind')?.value === BankDetailsChangePaymentMethod.BANK_TRANSFER) {
      this.form.get('iban')?.setValidators([Validators.required]);
    } else {
      this.form.get('iban')?.clearValidators();
    }
    this.form.get('iban')?.updateValueAndValidity();
    this.form.get('accountCoHolder')?.get('firstName')?.updateValueAndValidity();
    this.form.get('accountCoHolder')?.get('lastName')?.updateValueAndValidity();
  }
}